type GetAddToCartButtonLabel = {
    quantity: number;
    productsCount: number;
};

export const getAddToCartButtonLabel = ({ quantity, productsCount }: GetAddToCartButtonLabel) => {
    if (quantity === 1) {
        return 'Add to pickup';
    }

    if (quantity === productsCount) {
        return 'Add all to pickup';
    }

    return 'Add both to pickup';
};
